// extracted by mini-css-extract-plugin
export var category = "_kh-9";
export var categoryHeader = "_kh-e";
export var container = "_kh-0";
export var group = "_kh-a";
export var groupItems = "_kh-f";
export var groupSeparator = "_kh-j";
export var loading = "_kh-1";
export var noResults = "_kh-3";
export var placeholder = "_kh-2";
export var resultContent = "_kh-5";
export var resultIcon = "_kh-c";
export var resultItem = "_kh-g";
export var resultMeta = "_kh-8";
export var resultSubtitle = "_kh-7";
export var resultSuffix = "_kh-i";
export var resultTitle = "_kh-6";
export var resultsList = "_kh-4";
export var searchGroup = "_kh-d";
export var selected = "_kh-h";
export var subgroup = "_kh-b";